import { RootState } from '@store';

// Employee
export const selectEmployee = (state: RootState) => {
  return state.employee?.employee;
};

export const selectEmployeeId = (state: RootState) => {
  return state.employee?.employee?.employeeId;
};

export const selectEmployeeFirstName = (state: RootState) => {
  return state.employee?.employee?.firstName;
};

export const selectEmployeeLastName = (state: RootState) => {
  return state.employee?.employee?.lastName;
};

// Employee details
export const selectEmployeeDetails = (state: RootState) => {
  return state.employee?.employeeDetails;
};

export const selectIsAdminAllowed = (state: RootState) => {
  return state.employee?.employeeDetails?.isAdminAllowed;
};

export const selectIsMargin = (state: RootState) => {
  return state.employee?.employeeDetails?.isMargin;
};

export const selectIsMarginAllowed = (state: RootState) => {
  return state.employee?.employeeDetails?.isMarginAllowed;
};

export const selectIsIndependentDealerAllowed = (state: RootState) => {
  return state.employee?.employeeDetails?.isIndependentDealerAllowed;
};

export const selectIsTestUser = (state: RootState) => {
  return state.employee?.employeeDetails?.isTestUser;
};

export const selectDealerRoleType = (state: RootState) => {
  return state.employee?.employeeDetails?.dealerRoleType;
};

export const selectDealerId = (state: RootState) => {
  return state.employee?.employeeDetails?.dealerId;
};

export const selectDealerIds = (state: RootState) => {
  return state.employee?.employeeDetails?.dealerIds;
};

export const selectDealers = (state: RootState) => {
  return state.employee?.employeeDetails?.dealers;
};
